import { Routes } from 'common/constants/routes';

import { _request, APIMethod } from '../';
import { RequestParamsBase } from '../Models/CommonRequestModels';

import * as apiTypes from './ApplicationSuitesApiTypeDefs';

const SUITES_PATH_PREFIX = '/applicationsuites';

export const APISuiteGetList: APIMethod<RequestParamsBase|undefined, apiTypes.APISuiteGetListResponse> = (params?: RequestParamsBase) => (
    _request('GET', SUITES_PATH_PREFIX, undefined, params?.signal)
);

export const APISuiteGet: APIMethod<apiTypes.APISuiteGetParams, apiTypes.APISuiteGetResponse> = (params) => (
    _request('GET', `${SUITES_PATH_PREFIX}/${params.id}`)
);

export const APISuitePut: APIMethod<apiTypes.APISuitePutParams, apiTypes.APISuitePutResponse> = (params) => (
    _request('PUT', `${SUITES_PATH_PREFIX}/${params.id}`, {
        id: params.id,
        name: params.name,
    })
);

export const APISuitePost: APIMethod<apiTypes.APISuitePostParams, apiTypes.APISuitePostResponse> = (params) => (
    _request<apiTypes.APISuitePostResponse>('POST', SUITES_PATH_PREFIX, {
        name: params.name
    })
);

export const APISuiteDelete: APIMethod<apiTypes.APISuiteDeleteParams, apiTypes.APISuiteDeleteResponse> = (params) => (
    _request('DELETE', `${SUITES_PATH_PREFIX}/${params.id}`)
);

export const APISuiteGetTenants: APIMethod<apiTypes.APISuiteGetEntityParams, apiTypes.APIAPISuiteGetTenantsResponse> = (params) => (
    _request<apiTypes.APIAPISuiteGetTenantsResponse>('GET', `${SUITES_PATH_PREFIX}/${params.id}/${Routes.Tenants}`, undefined, params.signal)
);
